import { StyleDetail } from "./StyleDetail"
import { useTranslation } from "react-i18next"
import { useCallback, useState } from "react"
import { StyleResponseDTO } from "@/api/dto/styles"
import { useStyleRouteNavigation } from "@/routing/route-state"
import { useEffect } from "react"

interface StyleDetailWrapperProps {
	isPolarrStyle: boolean
	selectedStyleDetail: StyleResponseDTO
	onBack: () => void
	onUse: (style: StyleResponseDTO) => void
	className?: string
	isFullWidth?: boolean
	isLoadingUse?: boolean
	onStyleChange?: (style: StyleResponseDTO) => void
}

export const StyleDetailWrapper = ({
	isPolarrStyle,
	selectedStyleDetail,
	onBack,
	onUse,
	className,
	isFullWidth,
	isLoadingUse,
	onStyleChange,
}: StyleDetailWrapperProps) => {
	const { t } = useTranslation("components")
	const [currentStyle, setCurrentStyle] = useState<StyleResponseDTO>(selectedStyleDetail)
	const { toDetail } = useStyleRouteNavigation()

	useEffect(() => {
		setCurrentStyle(selectedStyleDetail)
	}, [selectedStyleDetail])

	const handleStyleChange = useCallback(
		(newStyle: StyleResponseDTO) => {
			setCurrentStyle(newStyle)
			onStyleChange?.(newStyle)
			void toDetail(newStyle.styleId)
		},
		[onStyleChange, toDetail],
	)

	const handleStyleChangeForDialog = useCallback(
		(newStyle: StyleResponseDTO) => {
			setCurrentStyle(newStyle)
			onStyleChange?.(newStyle)
		},
		[onStyleChange],
	)

	if (currentStyle) {
		return (
			<div className={`flex h-full min-h-0 flex-col ${className || ""}`}>
				<StyleDetail
					currentStyle={currentStyle}
					isPolarrStyle={isPolarrStyle}
					onBack={onBack}
					onUse={onUse}
					onStyleChange={isFullWidth ? handleStyleChange : handleStyleChangeForDialog}
					isFullWidth={isFullWidth}
					isLoadingUse={isLoadingUse}
				/>
			</div>
		)
	} else {
		return (
			<div className={`flex h-64 items-center justify-center ${className || ""}`}>
				<div className="text-center">
					<div className="mb-2 text-lg text-white">
						{t("styleDetailWrapper.styleNotFound")}
					</div>
					<div className="text-sm text-base-400">
						{t("styleDetailWrapper.unableToLoad")}
					</div>
					<button
						className="mt-4 rounded bg-accent-600 px-3 py-1 text-sm text-white hover:bg-accent-500"
						onClick={onBack}
					>
						{t("styleDetailWrapper.back")}
					</button>
				</div>
			</div>
		)
	}
}
